// import logo from './zen-brush-symbol';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Footer from './components/Footer'
import Greeting from './components/Greeting';



import React, {useState, useEffect} from 'react' 

import Clock from './Clock'
import Signup from './user/Signup'
import Signin from './user/Signin'
import MeditationList from './meditation/MeditationList';
import JournalCreateForm from './journal/JournalCreateForm';
import PassEditForm from './profile/PassEditForm';

//Importing Journal Components - Richard 20/7/22@15:22
import JournalList from './journal/JournalList'

import {BrowserRouter as Router, Route, Routes, Link, useNavigate} from 'react-router-dom'
import Axios from 'axios'
import jwt_decode from 'jwt-decode'
import Profile from './profile/Profile'
import Settings from './Settings' 
import Home from './components/Home';
import About from './components/About';

import {Alert} from 'react-bootstrap'  
import MeditationCreateForm from './meditation/MeditationCreateForm';

// import { getSuggestedQuery } from '@testing-library/react';

// Axios.defaults.baseURL=process.env.REACT_APP_AXIOS_BASE_PATH;
//  console.log(process.env.REACT_APP_AXIOS_BASE_PATH)

export default function App() {

  const [isAuth, setIsAuth] = useState(false);
  const [currentUser, setUser] = useState({}); // create a profile function and add this line
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [registerSuccess, setRegisterSuccess] = useState(null);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [visibleErrorAlert, setVisibleErrorAlert] = useState(false);
  
  let navigate = useNavigate();

  useEffect(() => {
    let token = localStorage.getItem("token");

    if(token != null){
      let user = jwt_decode(token);

      if(user){
        setIsAuth(true)
        setUser(user)
      }
      else if (!user){
        localStorage.removeItem("token");
        setIsAuth(false)
      }
    }
  }, [])

  const registerHandler = (user) => {
    Axios.post("auth/signup", user)
    .then(response => {
      console.log(response)
      handleSuccessMessage("You now have an account, you need to sign in!");
      setRegisterSuccess(true)
      navigate("/signin", { replace: true });
    })
    .catch(error => {
      console.log(error)
      handleErrorMessage("Error Creating User. Please try again.");
      setRegisterSuccess(false)
    })
  }

  const loginHandler = (cred) => {
    Axios.post("auth/signin", cred)
    .then(response => {
      console.log(response.data.token)
      if(response.data.token != null){
        localStorage.setItem("token", response.data.token);
        let user = jwt_decode(response.data.token);
        setIsAuth(true);
        setUser(user);
        handleSuccessMessage("User logged in successfully");
        navigate("meditation/index", { replace: true });
      }
    })
    .catch(error => {
      console.log(error);
      setIsAuth(false);
      handleErrorMessage("User not logged in, please try again");
    })
  }

  const onLogoutHandler = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    setIsAuth(false)
    setUser(null)
    handleSuccessMessage("User logged out successfully")
    navigate("/signin", { replace: true });
  }

  const seeAccountHandler = (user) => {
    Axios.get("profile/detail", user)
    .then(response => {
      console.log(response)
    })
    .catch(error => {
      console.log(error)
    })
  }

  const handleVisible = ( type ) => { 
    if(type === 'success'){
      setVisibleAlert(true)
      setTimeout(() => { 
          setVisibleAlert(false)
      }, 3000);
    } else {
      setVisibleErrorAlert(true)
      setTimeout(() => { 
        setVisibleErrorAlert(false)
      }, 3000);
    }
    
  } 

  const handleErrorMessage = (msg) => {
    setErrorMessage(msg);
    handleVisible("error");
  };

  const handleSuccessMessage = (msg) => {
    setSuccessMessage(msg);
    handleVisible("success");
  }



  const errMessage = errorMessage ? (
  <Alert show={visibleErrorAlert} variant="danger">{errorMessage}</Alert>
  ) : null;

  const succMessage = successMessage ? (
    <Alert show={visibleAlert} variant="success">{successMessage}</Alert>
    ) : null;
  

  return (
      <div className="wrapper">
        <Navbar bg="dark" variant="dark" sticky="top" expand="lg">
        <Container>
          <Navbar.Brand className="nav-brand">
            <Link to="/">Zen Journal</Link>
            </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav"/>
            <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="text-light ms-auto justify-content-end">
              { isAuth ? (
                  <>                                
                  <Nav.Item id="nav-welcome">
                  {currentUser ? "Welcome " + currentUser.user.firstName : null} {" "}
                  </Nav.Item>
                  <Nav.Item>
                    <Link to="/about">About Zen</Link> {" "}
                  </Nav.Item> 
                  <Nav.Item>
                    <Link to="/meditation/index">Meditations</Link> {" "}
                  </Nav.Item>            
                  <Nav.Item>
                    <Link to="/journal/index">Journal</Link> {" "}
                  </Nav.Item>
                  <Nav.Item>
                    <Link to="/profile/detail" onClick={seeAccountHandler}>My Account</Link> {" "}
                  </Nav.Item>
                  <Nav.Item>
                    <Link to="/logout" onClick = {onLogoutHandler}>Logout</Link> 
                  </Nav.Item>             
                  </>
              ) : (
                <>  
                  <Nav.Item>
                    <Link to="/">Home</Link> {" "}
                  </Nav.Item>
                  <Nav.Item>
                    <Link to="/about">About Zen</Link> {" "}
                  </Nav.Item>
                  <Nav.Item>
                    <Link to="/signup">Signup</Link> {" "}
                  </Nav.Item>
                  <Nav.Item>
                    <Link to="/signin">Signin</Link> {" "}  
                  </Nav.Item>            
                </>
              )}
          
          </Nav>
         </Navbar.Collapse>
        </Container>
        </Navbar>
          <div className="error-message">{errMessage}</div>
          <div className="succ-message">{succMessage}</div>
        <div style={{ minHeight: "100vh"}}>
          <Routes>
            <Route path="/" element={<Home isAuth={isAuth}></Home>}></Route>
            <Route path="/meditation/index" element={ isAuth ? <MeditationList currentUser={currentUser} handleSuccessMessage={handleSuccessMessage} handleErrorMessage={handleErrorMessage}></MeditationList> : <Signin login={loginHandler}></Signin>}></Route>
            <Route path="/profile/detail" element={ isAuth ? <Profile user={currentUser.user} handleSuccessMessage={handleSuccessMessage} handleErrorMessage={handleErrorMessage}></Profile> : <Signin login={loginHandler}></Signin>}></Route>
            <Route path="/journal/add/:meditation_id" element={ isAuth ? <JournalCreateForm handleSuccessMessage={handleSuccessMessage} handleErrorMessage={handleErrorMessage}></JournalCreateForm> : <Signin login={loginHandler}></Signin>}></Route>
            <Route path="/signup" element={<Signup register={registerHandler} registerSuccess={registerSuccess}></Signup>}></Route>
            <Route path="/signin" element={<Signin login={loginHandler}></Signin>}></Route>
            <Route path="/journal/index" element={ isAuth ? <JournalList handleSuccessMessage={handleSuccessMessage} handleErrorMessage={handleErrorMessage}></JournalList> : <Signin login={loginHandler}></Signin>}></Route>
            <Route path="/profile/password" element={ isAuth ? <PassEditForm handleSuccessMessage={handleSuccessMessage} handleErrorMessage={handleErrorMessage} currentUser={currentUser.user}></PassEditForm> : <Signin login={loginHandler}></Signin>}></Route>
            <Route path="/about" element={<About></About>}></Route>
          </Routes>
        </div>
        <Footer/>
      </div>
    
  )
  // function testAudio() {

}